export const etsyApp = {
  id: 104,
  name: "etsy",
  label: "Etsy",
  isMarketplace: true,
  useOAuth: true,
  showTestConnection: false,
  logo: process.env.BASE_URL + "media/shopLogos/etsy.png",
  areaBlacklist: ["migration", "reporting"],
  environmentVariables: {
    presetId: process.env?.VUE_APP_SCM_APP_ETSY_PRESET_ID
  }
};
